import {Component, OnDestroy, OnInit} from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import {select, Store} from '@ngrx/store';
import {TaskManagerState} from '../../store/task-manager.reducer';
import {GetCompanyInfoAction} from '../../store/task-manager.action';
import {Subject} from 'rxjs';
import {getCompanyInfo} from '../../store/task-manager.selector';
import {takeUntil} from 'rxjs/operators';

@Component({
    standalone: false,
    selector: 'particle-company-info',
  templateUrl: './company-info.component.html',
  styleUrls: ['./company-info.component.scss']
})
export class CompanyInfoComponent implements OnInit, OnDestroy {

  currentTabIndex = 0;
  contextPath: string;
  userName: string;
  commentSourceType = 'Company Info';
  commentTitle = 'Company Comment';
  scope = 3;
  messageType = 3;
  conversationType = 2;
  dynamicData: any;
  data: any;
  companyInfo: any;
  unSubscribe$ = new Subject<void>();
  constructor(private taskManagerStore: Store<TaskManagerState>) { }

  ngOnInit() {
    console.log('Inside Company Info', this.dynamicData);
    console.log('Data', this.data);
    this.taskManagerStore.pipe(select(getCompanyInfo), takeUntil(this.unSubscribe$)).subscribe(company => {
        this.companyInfo = company;
    });

    const companyId = this.dynamicData.card.createdBy.companyId;
    this.contextPath = this.dynamicData.card.createdBy.userName;
    this.taskManagerStore.dispatch(new GetCompanyInfoAction(companyId));
  }

  selectedTabChange(tabChangeEvent: MatTabChangeEvent) {
    this.currentTabIndex = tabChangeEvent.index;
  }

  ngOnDestroy (): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

}
